const urls = require('../../../api/ispyb')
const axios = require('axios');
const qs = require('qs');

export const getSaxsExtendedSubtractionsByExperimentId = (token, proposal, experimentId, onSuccess, onError) => {
    axios({
        method: 'GET',
        url: urls.getSaxsExtendedSubtractionsByExperimentId(token, proposal, experimentId),
    })
        .then(response => onSuccess(response))
        .catch(error => onError(error));
}


export const getSaxsExperimentsBySessionId = (token, proposal, sessionId, onSuccess, onError) => {
    axios({
        method: 'GET',
        url: urls.getSaxsExperimentsBySessionId(token, proposal, sessionId),
    })
        .then(response => onSuccess(response))
        .catch((error) => onError(error));
}

/**  * Get datacollections by datacollectionIds  */
export const getSaxsDataCollectionsAsBeanByDataCollectionIds = (token, proposal, datacollectionId, onSuccess, onError) => {
    axios({
        method: 'GET',
        url: urls.getSaxsDataCollectionsAsBeanByDataCollectionIds(token, proposal, datacollectionId),
    })
        .then(response => onSuccess(response))
        .catch((error) => onError(error));
}

/** Get subtractions by datacollectionIds */
export const getSaxsSubtractionsAsListByDataCollectionIds = (token, proposal, dataCollectionId, onSuccess, onError) => {
    axios({
        method: 'GET',
        url: urls.getSubtractionsAsListByDataCollectionIds(token, proposal, dataCollectionId)
    })
        .then(response => onSuccess(response))
        .catch((error) => onError(error));
}

/** Get subtractions by subtractionId */
export const getSaxsSubtractionAsListBySubtractionId = (token, proposal, subtractionId, onSuccess, onError) => {
    axios({
        method: 'GET',
        url: urls.getSaxsSubtractionAsListBySubtractionId(token, proposal, subtractionId)
    })
        .then(response => onSuccess(response))
        .catch((error) => onError(error));
}


export const getSaxsExtendedMergesByMergeIds = (token, proposal, mergeIds, onSuccess, onError) => {
    axios({
        method: 'GET',
        url: urls.getExtendedMergesByMergeIds(token, proposal, mergeIds)
    })
        .then(response => onSuccess(response))
        .catch((error) => onError(error));
}

export const getPlottingDataByFrame = (token, frameId, averageId, subtractedId, sampleAverageId, bufferAverageId, models, operation, onSuccess, onError) => {
    axios({
        method: 'GET',
        url: urls.getPlottingDataByFrame(token, frameId, averageId, subtractedId, sampleAverageId, bufferAverageId, models, operation)
    })
        .then(response => onSuccess(response))
        .catch((error) => onError(error));
}

export const getSaxsHPLCFrame = (token, proposal, experimentId, frameId, onSuccess, onError) => {
    axios({
        method: 'GET',
        url: urls.getSaxsHPLCFrame(token, proposal, experimentId, frameId)
    })
        .then(response => onSuccess(response))
        .catch((error) => onError(error));
}

export const getFirContentByModelId = (token, proposal, subtractionId, modelId, onSuccess, onError) => {
    axios({
        method: 'GET',
        url: urls.getFirContentByModelId(token, proposal, subtractionId, modelId)
    })
        .then(response => onSuccess(response))
        .catch((error) => onError(error));
}

export const getFitContentByModelId = (token, proposal, subtractionId, modelId, onSuccess, onError) => {
    axios({
        method: 'GET',
        url: urls.getFitContentByModelId(token, proposal, subtractionId, modelId)
    })
        .then(response => onSuccess(response))
        .catch((error) => onError(error));
}


export const getPlottingDataByFramePromise = (token, frame, frameId, averageId, subtractedId, sampleAverageId, bufferAverageId, models, operation) => {
    return new Promise((resolve, reject) => axios({
        method: 'GET',
        url: urls.getPlottingDataByFrame(token, frameId, averageId, subtractedId, sampleAverageId, bufferAverageId, models, operation)
    }).then(response => resolve({ response: response, frame: frame }))
        .catch(error => reject({ error: error, frame: frame }))
    );
}


export const getPDB = (token, proposal, models, superpositions, onSuccess, onError) => {
    axios({
        method: 'POST',
        url: urls.getPDB(token, proposal),
        data: qs.stringify({ models: JSON.stringify(models) }),
    })
        .then(response => onSuccess(response))
        .catch((error) => onError(error));
}


export const getHPLCOverviewByExperimentId = (token, proposal, experimentId, onSuccess, onError) => {
    axios({
        method: 'GET',
        url: urls.getHPLCOverviewByExperimentId(token, proposal, experimentId)
    })
        .then(response => onSuccess(response))
        .catch((error) => onError(error));
}


export const getSaxsExperimentByExperimentId = (token, proposal, experimentId, onSuccess, onError) => {
    axios({
        method: 'GET',
        url: urls.getSaxsExperimentByExperimentId(token, proposal, experimentId)
    })
        .then(response => onSuccess(response))
        .catch((error) => onError(error));
}


// WEBPACK FOOTER //
// ./src/containers/saxs/helpers/IORequests.js